import { useEffect } from "react";
import ReactGA from "react-ga4";

const isMobileOrTablet = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

const EmailVariant = ({ modalOpen, setModalOpen }) => {
  useEffect(() => {
    if (!modalOpen) return;

    // Track event
    ReactGA.event("get_in_touch_click");

    const email = "foundry@nowpurchase.com";
    const subject = "Ready to Connect with the NowPurchase Team!";
    const gmailWebUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}&su=${encodeURIComponent(subject)}`;

    if (isMobileOrTablet()) {
      // Mobile/Tablet: Only try to open Gmail app
      const gmailAppUrl = `googlegmail://co?to=${encodeURIComponent(email)}&subject=${encodeURIComponent(subject)}`;

      // Try to open Gmail app only
      window.location.href = gmailAppUrl;
    } else {
      // Desktop/Laptop: Open in new tab
      window.open(gmailWebUrl, "_blank");
    }

    setModalOpen(false);
  }, [modalOpen, setModalOpen]);

  return null;
};

export default EmailVariant;
